<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Libraires
        <span class="separator" />
      </h1>
    </b-col>
    <ListeStatsLibraires />
  </div>
</template>

<script>
import ListeStatsLibraires from "@/components/stats/ListeStatsLibraires.vue";

export default {
  name: "StatsLibraires",
  components: {
    ListeStatsLibraires,
  },
};
</script>

<style lang="scss" scoped>
</style>
